export const isDateInFuture = (date) => {
  return new Date(date) > new Date();
};
